import { useReducer } from 'react';

/**
 * Force rerender a component.
 * This is an anti-pattern and should only be used as an escape hatch if no other solution exists.
 */
export const useRerender = () => useReducer(() => ({}), {})[1] as () => void;
